import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QrScannerModule } from '@uex/ngx-qrscanner';

import { QRScannerComponent } from './qr-scanner.component';

export { QRScannerComponent } from './qr-scanner.component';

@NgModule({
  declarations: [
    QRScannerComponent
  ],
  imports: [
    CommonModule,
    QrScannerModule
  ],
  exports: [
    QRScannerComponent
  ]
})
export class QRScannerModule {}
